// GSAP is an optional runtime dependency. Component-builder pages can load it
// for animations while shell pages deliberately omit it from their initial JS.
const gsapInstance = globalThis.gsap;
const scrollTriggerInstance = globalThis.ScrollTrigger;
const hasGsap = typeof gsapInstance?.fromTo === 'function';
const hasScrollTrigger = Boolean(scrollTriggerInstance && typeof gsapInstance?.registerPlugin === 'function');

if (hasScrollTrigger) gsapInstance.registerPlugin(scrollTriggerInstance);

/**
 * Initializes animations for elements with a `data-animation` attribute.
 * Supports both on-load and on-scroll animations.
 * @param {string} selector - The selector for elements to animate (e.g., '[data-animation]').
 */
export function initializePageAnimations(selector = '[data-animation]') {
    if (!hasGsap) return;
    const elementsToAnimate = document.querySelectorAll(selector);

    elementsToAnimate.forEach((el, index) => {
        const animationType = el.dataset.animation;
        const triggerOnScroll = el.dataset.trigger === 'scroll';
        const delay = parseFloat(el.dataset.delay) || 0;
        const duration = parseFloat(el.dataset.duration) || 1;

        if (!animationType || animationType === 'none') return;

        let fromState = { opacity: 0 };
        if (animationType === 'fadeInUp') fromState.y = 50;
        if (animationType === 'fadeInDown') fromState.y = -50;
        if (animationType === 'slideInLeft') fromState.x = -50;
        if (animationType === 'slideInRight') fromState.x = 50;
        if (animationType === 'scaleIn') fromState.scale = 0.8;

        let toState = {
            opacity: 1,
            y: 0,
            x: 0,
            scale: 1,
            duration: duration,
            delay: delay,
            ease: 'power3.out'
        };

        if (triggerOnScroll && hasScrollTrigger) {
            // This animation will only play when the element scrolls into view
            toState.scrollTrigger = {
                trigger: el,
                start: 'top 85%', // Start animation when 85% of the element is visible
                toggleActions: 'play none none none',
            };
        }

        gsapInstance.fromTo(el, fromState, toState);
    });
}
